export default __webpack_public_path__ + "assets/4e378fe2bbf5b9677589b53f4f911c60.svg";